module.exports = __webpack_public_path__ + "static/media/Hurray.baf4aa87.svg";